import React from 'react';
interface GlucoseCurveProps {
  className?: string;
}

/** Comparison of a spiking glucose curve (gold, dashed) vs a flattened one (forest). */
export function GlucoseCurve({
  className = ''
}: GlucoseCurveProps) {
  return <figure className={className} data-id="element-421" data-mp="2wloeuuk0cdbc">
      <svg viewBox="0 0 420 160" className="h-auto w-full" role="img" aria-label="Comparación entre una curva de glucosa con picos pronunciados y una curva aplanada y estable" data-id="element-422" data-mp="2wisdsxcv58io">
        <g stroke="#e2e6dc" strokeWidth="1" data-id="element-423" data-mp="3p90tmijxfgu3">
          <line x1="40" y1="20" x2="400" y2="20" data-id="element-424" data-mp="3kaphu2a2mw98" />
          <line x1="40" y1="60" x2="400" y2="60" data-id="element-425" data-mp="3kaz7tpv493ex" />
          <line x1="40" y1="100" x2="400" y2="100" data-id="element-426" data-mp="3g8m6rerbdtoh" />
          <line x1="40" y1="140" x2="400" y2="140" data-id="element-427" data-mp="3g719hhdm7wmx" />
        </g>
        <line x1="40" y1="14" x2="40" y2="140" stroke="#c9cfc2" strokeWidth="1.5" data-id="element-428" data-mp="3bako2uxsvwdj" />

        <path d="M40 120 C 80 120, 95 22, 130 26 C 165 30, 175 132, 215 128 C 250 124, 262 34, 300 38 C 338 42, 350 130, 400 126" fill="none" stroke="#d4af37" strokeWidth="2.5" strokeDasharray="6 5" strokeLinecap="round" data-id="element-429" data-mp="24u8kufg4fob3" />
        <path d="M40 120 C 90 118, 120 96, 170 94 C 230 92, 270 100, 320 98 C 360 97, 380 104, 400 102" fill="none" stroke="#1a472a" strokeWidth="3.5" strokeLinecap="round" data-id="element-430" data-mp="8kgr5hhried2" />

        <text x="46" y="14" fill="#888888" fontSize="10" fontFamily="Inter, sans-serif" data-id="element-431" data-mp="3vomzch45emit">
          glucosa
        </text>
      </svg>
      <figcaption className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-muted" data-id="element-432" data-mp="4ghjzpidgrwd">
        <span className="flex items-center gap-2" data-id="element-433" data-mp="3lwqyiyaogiaw">
          <span className="h-0.5 w-6 rounded-full bg-gold" aria-hidden="true" data-id="element-434" data-mp="3qoqtsdfsyn15" />
          Mismo plato, orden aleatorio
        </span>
        <span className="flex items-center gap-2" data-id="element-435" data-mp="3cync7zrvbhi1">
          <span className="h-[3px] w-6 rounded-full bg-forest" aria-hidden="true" data-id="element-436" data-mp="3gz78z28j4j3n" />
          Mismo plato, con secuenciación
        </span>
      </figcaption>
    </figure>;
}